// The words of the account pages the browser writes itself: sign-up, login, verification, password.
import { words } from "../services/i18n.ts";

export const t = words({
    en: {
        error: "An error occurred. Please try again.",
        show: "Show",
        hide: "Hide",
        showPassword: "Show password",
        hidePassword: "Hide password",
        loginFailed: "Could not log in.",
        loginOk: "Login successful! Redirecting...",
        badResetLink: "Invalid reset link. Please request a new password reset.",
        noToken: "No verification token provided.",
        verified: "Email verified. Now let's bring your games in…",
        passwordRule: "Password must be at least 8 characters with uppercase, lowercase, and a digit.",
        passwordsDiffer: "Passwords do not match.",
        practicesSaved: (practices: number, xp: number) =>
            `Your ${practices} practice${practices === 1 ? "" : "s"} and ${xp} XP on this device will be saved to your account.`,
    },
    es: {
        error: "Algo ha fallado. Inténtalo de nuevo.",
        show: "Mostrar",
        hide: "Ocultar",
        showPassword: "Mostrar la contraseña",
        hidePassword: "Ocultar la contraseña",
        loginFailed: "No se ha podido iniciar sesión.",
        loginOk: "Sesión iniciada. Entrando...",
        badResetLink: "El enlace no es válido. Pide un nuevo enlace para cambiar la contraseña.",
        noToken: "Falta el código de verificación del enlace.",
        verified: "Email verificado. Ahora vamos a traer tus partidas…",
        passwordRule: "La contraseña necesita al menos 8 caracteres, con mayúsculas, minúsculas y un número.",
        passwordsDiffer: "Las contraseñas no coinciden.",
        practicesSaved: (practices: number, xp: number) =>
            `${practices === 1 ? "Tu práctica" : `Tus ${practices} prácticas`} y ${xp} XP de este dispositivo se guardarán en tu cuenta.`,
    },
});
